import { classNames } from 'libs/react';
import { Image } from 'components/Image';
import { React } from 'libs/react';
import i18n from 'components/translation/i18n';
import { Button } from 'components/Button';
import { useModal } from 'components/modal/ModalStack';
import { HelpModal } from './components/HelpModal';
import { useDomain } from 'components/domain/DomainProvider';
import { imageSources, LOGO_SIZES } from 'helpers/mediaSources';
import './DynamicSalesFormHeader.scss';
/**
 * @component DynamicSalesFormHeader
 * @since 1.0.0
 */
export function DynamicSalesFormHeader(props) {
    const { configurationFields, logo, isStoreMode } = props;
    const modal = useModal();
    const { name } = useDomain();
    const language = i18n.language.substring(0, 2);
    const headLineConfig = configurationFields === null || configurationFields === void 0 ? void 0 : configurationFields.find((conf) => conf.fieldKey ===
        (isStoreMode
            ? 'DIRECT_SALES_FORM_HEADLINE'
            : 'DYNAMIC_SALES_FORM_HEADLINE'));
    const headLineTranslations = JSON.parse(headLineConfig === null || headLineConfig === void 0 ? void 0 : headLineConfig.value);
    const headLine = headLineTranslations.translations[language];
    document.title = name + ' | ' + headLine;
    /**
     * @function showHelp
     * @since 1.0.0
     * @hidden
     */
    const showHelp = () => {
        modal.present({
            title: t('Help'),
            picto: 'question',
            className: 'dynamic-sales-form-help-modal',
            modal: React.createElement(HelpModal, null)
        });
    };
    const className = classNames('dynamic-sales-form-header', props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "dynamic-sales-form-header-main" },
            React.createElement("div", { className: "dynamic-sales-form-header-head" },
                React.createElement(Image, Object.assign({ eager: true, className: "dynamic-sales-form-header-logo" }, ((logo === null || logo === void 0 ? void 0 : logo.url)
                    ? imageSources(logo, LOGO_SIZES)
                    : { source: '/images/menu-bar-logo-icon.svg' }), { onClick: () => {
                        const element = document.getElementById('dynamic-sales-form-view-banner');
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    } }))),
            React.createElement("div", { className: "dynamic-sales-form-header-body" },
                React.createElement("h1", { className: "dynamic-sales-form-header-title" }, headLine)),
            React.createElement("div", { className: "dynamic-sales-form-header-foot" },
                React.createElement(Button, { style: "outline", size: "small", picto: "question", className: "dynamic-sales-form-header-button", onPress: () => {
                        showHelp();
                    } })))));
}
